import React, { Component } from "react";
import styled from "styled-components";
import flatpickr from "flatpickr";
import "flatpickr/dist/flatpickr.min.css";
import { Norwegian } from "flatpickr/dist/l10n/no.js";
import WP from "WP";
import { currentLanguage } from "helpers";

import GridElement from "partials/GridElement";
import Button from "partials/Button";

import Arrow from "icons/ArrowIcon";

export class DateRangePicker extends Component {
  constructor(props) {
    super(props);
    this.state = {
      inputWidth: 154,
      open: false,
    };
    this.datePickr = React.createRef();
  }

  componentDidMount() {
    let { fromDate, toDate } = this.props;

    flatpickr.l10ns.no.rangeSeparator = " ─ ";
    flatpickr.l10ns.no.weekdays.shorthand =
      flatpickr.l10ns.no.weekdays.shorthand.map((day) => day.toUpperCase());
    flatpickr.l10ns.no.months.shorthand =
      flatpickr.l10ns.no.months.shorthand.map((month) => month.toUpperCase());

    let options = {
      locale: Norwegian,
      mode: "range",
      minDate: "today",
      altInput: true,
      altFormat: "D. j. M",
      dateFormat: "Y-m-d\\TH:S" /* 'D. j. M' */,
      onChange: this.props.dateHandler,
      onOpen: this.toggleContent,
      onClose: this.toggleContent,
      showMonths: 1,
      arrowTop: false,
    };

    if (fromDate && toDate) {
      fromDate = new Date(fromDate);
      toDate = new Date(toDate);

      options.defaultDate = [fromDate, toDate];
    }

    flatpickr(this.datePickr.current, options);
    this.setState({
      altInput: flatpickr(this.datePickr.current, options).altInput.value,
    });
    setTimeout(() => this.getInputWidth(), 1500);
  }

  getInputWidth = () => {
    let hiddenDiv = document.getElementById("hidden");

    if (hiddenDiv && hiddenDiv.innerText) {
      let width = hiddenDiv.offsetWidth + 114;
      this.setState({ inputWidth: width });
    }
  };

  toggleContent = () => {
    this.setState({ open: !this.state.open });
  };

  render() {
    const { inputWidth, altInput, open } = this.state;

    return (
      <StyledLabel className={this.props.className} inputWidth={inputWidth}>
        <input
          ref={this.datePickr}
          defaultValue={this.props.dateStr}
          placeholder={
            (currentLanguage() === "no" ? "Fra   ─   Til" : "From   ─   To",
            WP.trans.chooseDates)
          }
          id='datepicker'
        />
        <div id='hidden'>
          <p>{altInput}</p>
        </div>
        {open && (
          <InputContainer>
            <GridElement colStart={1} colEnd={5} align='center'>
              {altInput}
            </GridElement>
            <GridElement colStart={6} colEnd={8} align='stretch'>
              <Button>
                <StyledArrow />
              </Button>
            </GridElement>
          </InputContainer>
        )}
      </StyledLabel>
    );
  }
}

export default DateRangePicker;

const StyledLabel = styled.label`
  margin-bottom: ${(props) => props.theme.spacing.contentL};
  width: 100%;

  input {
    cursor: pointer;
    border: none;
    padding: 0;
    width: 100%;
    font-size: 11px;
    line-height: 21px;
    font-weight: 600;
    font-family: "Untitled";
    color: ${(props) => props.theme.colors.text};

    &::-webkit-input-placeholder {
      color: ${(props) => props.theme.colors.text};
    }
  }

  #hidden {
    position: absolute;
    display: inline;
    left: 5000px;
    padding: 0;
    margin: 0;
  }
`;

const InputContainer = styled.div`
  position: fixed;
  bottom: 30px;
  left: 30px;
  right: 30px;
  z-index: 10000000;
  display: grid;
  grid-template-columns: repeat(3, 1fr 0.13fr) 1fr;
`;

const StyledArrow = styled(Arrow)`
  fill: ${(props) => props.theme.colors.negative};
`;
